import React, { useEffect } from "react";
import { Flex } from "rebass";
import Project from "./Project";
import imgCover1 from "../img/book.png";
import imgCover2 from "../img/book.png";
import imgCover3 from "../img/book.png";
import styled from "styled-components";

const projects = [
  {
    number: "01",
    title: "DESIGN SYSTEM(s)",
    tagline: "Scaleable systematic approach to build-in visual consistency. Based on OOUX.",
    desc: "First desc",
    discipline: "UI/FE",
    url: imgCover1,
    id: "1",
    page: "/design-system/",
    year: "2019 - 2020",
  },
  {
    number: "02",
    title: "LAPIERRE",
    tagline: "Design System applied, from brand book to a complete shopping experience.",
    desc: "Second desc",
    discipline: "UI/DS/FE",
    url: imgCover2,
    id: "2",
    page: "/lapierre/",
    year: "2020 - 2021",
  },
  {
    number: "03",
    title: "eCOMMERCE",
    tagline: "Headless eCommerce Platform for Multi-Brands. Build on Gatsby.",
    desc: "Second desc",
    discipline: "DS/UI/FE",
    url: imgCover3,
    id: "3",
    page: "/ecom-platform/",
    year: "2018",
  },
];

 const ProjectsListing = () => {
    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
    return (
      <StyledSection>
        <Flex
          flexWrap="wrap"
          alignItems="center"
          variant="containerHeader"
        >
          {/* Project list */}
          {projects.map((project, index) => (
            <Project
              url={project.url}
              tagline={project.tagline}
              number={project.number}
              page={project.page}
              title={project.title}
              discipline={project.discipline}
              year={project.year}
              id={project.id}
              key={project.id.toString()}
              index={index}
            />
          ))}
        </Flex>
      </StyledSection>
    );
  }

const StyledSection = styled.section`
  position: relative;
  z-index: 2;
  margin-top: 0.8rem;
`;

export default ProjectsListing;
